import apiService from "@/core/services/apiService";

export type State = { classes: object };
import {Module, VuexModule, Mutation, Action} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/store.enums";
import {ProductsActions, ProductsMutation} from "@/modules/products/store/enums";
import store from "@/store";

@Module
export default class Store extends VuexModule {
    renderKey = 1;
    listParams = {
        page: 1,
        results: 10,
        search: null,
        sort: [],
        filter: {}
    };
    listCache = [];
    listTotal = 0;

    inventoryOverviewCache = [];
    inventoryOverviewTotal = 0;
    inventoryAlertsCache = [];
    inventoryAlertsTotal = 0;

    get getProductsRenderKey() {
        return 'products-' + this.renderKey;
    }

    get getProductsLastListResult() {
        return this.listCache;
    }

    get getProductsLastListTotal() {
        return this.listTotal;
    }

    get getProductsInventoryOverview() {
        return this.inventoryOverviewCache;
    }

    get getProductsInventoryOverviewTotal() {
        return this.inventoryOverviewTotal;
    }

    get getProductsInventoryAlerts() {
        return this.inventoryAlertsCache;
    }

    get getProductsInventoryAlertsTotal() {
        return this.inventoryAlertsTotal;
    }

    @Mutation
    [ProductsMutation.SET_RENDER_UPDATE]() {
        this.renderKey++;
    }

    @Mutation
    [ProductsMutation.SET_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.listParams = listParams;
        this.listCache = listCache;
        this.listTotal = listTotal;
    }

    @Mutation
    [ProductsMutation.SET_INVENTORY_OVERVIEW]({listTotal, listCache}) {
        this.inventoryOverviewCache = listCache;
        this.inventoryOverviewTotal = listTotal;
    }

    @Mutation
    [ProductsMutation.SET_INVENTORY_ALERTS]({listTotal, listCache}) {
        this.inventoryAlertsCache = listCache;
        this.inventoryAlertsTotal = listTotal;
    }

    @Action
    [ProductsActions.REFRESH_LIST]() {
        this.context.dispatch(ProductsActions.FETCH_LIST, this.listParams);
    }

    @Action
    [ProductsActions.FETCH_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("products/list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ProductsMutation.SET_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.GET_ITEM](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`products/get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.CREATE_ITEM](payload) {

        return new Promise((resolve, reject) => {

            const {data} = payload;

            apiService.post('products/create', data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ProductsMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ProductsActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.UPDATE_ITEM](payload) {

        return new Promise((resolve, reject) => {

            const {id, data} = payload;

            apiService.put(`products/update/${id}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.DELETE_ITEM](deleteId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`products/delete/${deleteId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ProductsMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ProductsActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.UPDATE_DESCRIPTION](payload) {

        return new Promise((resolve, reject) => {

            const {id, data} = payload;

            apiService.post(`products/update-description/${id}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.UPLOAD_IMAGE](payload) {

        return new Promise((resolve, reject) => {

            const {id, formData} = payload;

            apiService.post(`products/upload-image/${id}`, formData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.DELETE_IMAGE](imageId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`products/delete-image/${imageId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.SORT_IMAGES](payload) {

        return new Promise((resolve, reject) => {

            const {id, data} = payload;

            apiService.post(`products/sort-images/${id}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.FETCH_VARIANTS](productId) {

        return new Promise((resolve, reject) => {

            apiService.get(`products/variants/${productId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.CREATE_VARIANT](payload) {

        return new Promise((resolve, reject) => {

            const {data} = payload;

            apiService.post('products/create-variant', data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.UPDATE_VARIANT](payload) {

        return new Promise((resolve, reject) => {

            const {variantId, data} = payload;

            apiService.put(`products/update-variant/${variantId}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.DELETE_VARIANT](variantId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`products/delete-variant/${variantId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.FETCH_CATEGORIES]() {

        return new Promise((resolve, reject) => {

            apiService.get('products/categories').then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.UPDATE_CATEGORIES](payload) {

        return new Promise((resolve, reject) => {

            const {id, data} = payload;

            apiService.post(`products/update-categories/${id}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.FETCH_DELIVERY_OPTIONS]() {

        return new Promise((resolve, reject) => {

            apiService.get('products/delivery-options').then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.UPDATE_DELIVERY_OPTIONS](payload) {

        return new Promise((resolve, reject) => {

            const {id, data} = payload;

            apiService.post(`products/update-delivery-options/${id}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.FETCH_ATTRIBUTES]() {

        return new Promise((resolve, reject) => {

            apiService.get('products/attributes').then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.UPDATE_ATTRIBUTES](payload) {

        return new Promise((resolve, reject) => {

            const {id, data} = payload;

            apiService.post(`products/update-attributes/${id}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.FETCH_INGREDIENTS]() {

        return new Promise((resolve, reject) => {

            apiService.get('products/ingredients').then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.UPDATE_INGREDIENTS](payload) {

        return new Promise((resolve, reject) => {

            const {id, data} = payload;

            apiService.post(`products/update-ingredients/${id}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.FETCH_GRADUATED_PRICES](productId) {

        return new Promise((resolve, reject) => {

            apiService.get(`products/graduated-prices/${productId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.UPDATE_GRADUATED_PRICES](payload) {

        return new Promise((resolve, reject) => {

            const {id, data} = payload;

            apiService.post(`products/update-graduated-prices/${id}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.FETCH_CROSS_SELLING](productId) {

        return new Promise((resolve, reject) => {

            apiService.get(`products/cross-selling/${productId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.UPDATE_CROSS_SELLING](payload) {

        return new Promise((resolve, reject) => {

            const {id, data} = payload;

            apiService.post(`products/update-cross-selling/${id}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.FETCH_INVENTORY](productId) {

        return new Promise((resolve, reject) => {

            apiService.get(`products/inventory/${productId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.ADD_INVENTORY](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('products/add-inventory', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.MOVE_INVENTORY](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('products/move-inventory', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.DELETE_INVENTORY](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('products/delete-inventory', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ═══════════════════════════════════════════════════════
    // Videos
    // ═══════════════════════════════════════════════════════

    @Action
    [ProductsActions.FETCH_VIDEOS](productId) {

        return new Promise((resolve, reject) => {

            apiService.get(`products/videos/${productId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ProductsActions.UPLOAD_VIDEO](payload) {

        return new Promise((resolve, reject) => {

            const {id, formData} = payload;

            apiService.post(`products/upload-video/${id}`, formData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ProductsActions.DELETE_VIDEO](mediaId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`products/delete-video/${mediaId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    // ═══════════════════════════════════════════════════════
    // Downloads
    // ═══════════════════════════════════════════════════════

    @Action
    [ProductsActions.FETCH_DOWNLOADS](productId) {

        return new Promise((resolve, reject) => {

            apiService.get(`products/downloads/${productId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ProductsActions.UPLOAD_DOWNLOAD](payload) {

        return new Promise((resolve, reject) => {

            const {id, formData} = payload;

            apiService.post(`products/upload-download/${id}`, formData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ProductsActions.DELETE_DOWNLOAD](downloadId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`products/delete-download/${downloadId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    // ═══════════════════════════════════════════════════════
    // Inventory Overview + Alerts
    // ═══════════════════════════════════════════════════════

    @Action
    @Action
    [ProductsActions.FETCH_FACETTES](productId) {

        return new Promise((resolve, reject) => {

            apiService.get("products/facettes/" + productId).then((response) => {

                const data = response.data || null;
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result || []);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.UPDATE_FACETTES]({ id, facettes }) {

        return new Promise((resolve, reject) => {

            apiService.post("products/update-facettes/" + id, { facettes } as any).then((response) => {

                const data = response.data || null;
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.FETCH_PRODUCTIONS](productId) {

        return new Promise((resolve, reject) => {

            apiService.get("products/productions/" + productId).then((response) => {

                const data = response.data || null;
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result || []);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.CREATE_PRODUCTION](productionData) {

        return new Promise((resolve, reject) => {

            apiService.post("products/create-production", productionData as any).then((response) => {

                const data = response.data || null;
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.DELETE_PRODUCTION](productionId) {

        return new Promise((resolve, reject) => {

            apiService.delete("products/delete-production/" + productionId).then((response) => {

                const data = response.data || null;
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.FETCH_INVENTORY_OVERVIEW](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("products/inventory-overview", params).then((response) => {

                const data = response.data || null;
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ProductsMutation.SET_INVENTORY_OVERVIEW, {
                    listTotal: data.results || 0,
                    listCache: data.result || []
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.FETCH_INVENTORY_ALERTS](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("products/inventory-alerts", params).then((response) => {

                const data = response.data || null;
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ProductsMutation.SET_INVENTORY_ALERTS, {
                    listTotal: data.results || 0,
                    listCache: data.result || []
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.LOOKUP_EAN](ean) {

        return new Promise((resolve, reject) => {

            apiService.post("products/lookup-ean", { ean } as any).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ProductsActions.FETCH_INVENTORY_MOVEMENTS](variantId) {

        return new Promise((resolve, reject) => {

            apiService.get("products/inventory-movements/" + variantId).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

}
